import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useBrowserStore } from '@/stores/browser';

export const useDeviceSize = () => {
  const browserStore = useBrowserStore();
  const { deviceSize, isViewportReady } = storeToRefs(browserStore);

  const isMobile = computed(() => deviceSize.value === 'mobile');
  const isTablet = computed(() => deviceSize.value === 'tablet');
  const isDesktop = computed(() => deviceSize.value === 'desktop');

  const isMobileOrTablet = computed(() => isMobile.value || isTablet.value);

  const deviceBreakpoint = computed<'mobile' | 'desktop' | null>(() => {
    if (!isViewportReady.value) return null;
    return isDesktop.value ? 'desktop' : 'mobile';
  });

  return {
    deviceSize,
    isViewportReady,
    isMobile,
    isTablet,
    isDesktop,
    isMobileOrTablet,
    deviceBreakpoint,
  };
};
